import { useParams } from "react-router-dom";
import RegionSidebar from "../components/RegionSidebar.jsx";
import RegionPanel from "../components/RegionPanel.jsx";
import { useAwsConfig } from '../../../../../context/Dashboard/aws/contextConfig.js';

export default function RegionViewAws() {
  const service_name = useParams().service;
  const { cAwsConfigAll : data } = useAwsConfig();
  const regionData = data.services[service_name].regions;

  return (
    <div className="region-layout">
      <RegionSidebar regions={regionData} />
      <RegionPanel regions={regionData} service_name={service_name} />
    </div>
  );
}
